module.exports = __webpack_public_path__ + "static/media/logout.177297f0.svg";